
import '../index.css';

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';


import {
  ActivityIcon,
  IconChip,
  InsightsIcon,
  CalendarIcon,
  PlanIcon,
  RocketIcon,
  DirectionIcon,
} from '../../../components/ui/AppIcon';

import StatusBadge from '../../../components/ui/StatusBadge';





import http from '../../../api/http';

const reportRecords = async (slug, params = {}) => {
  const response = await http.get(`/reports/${slug}`, { params });
  return response.data;
};





const model = {

  reports: [
    {
      handle: 'summary',
      slug: 'summary',
      params: { windowDays: 30 }
    },
    {
      handle: 'activity',
      slug: 'activity',
      params: { limit: 8 }
    },
  ],

  collections: [
    {
      handle: 'directionalStrategies',
      slug: 'directional-strategies',
      params: { limit: 100, page: 1, sort: 'updatedAt', order: 'DESC' }
    },
    {
      handle: 'stratPlans',
      slug: 'strat-plans',
      params: { limit: 100, page: 1, sort: 'updatedAt', order: 'DESC' }
    },
    {
      handle: 'sprintPacks',
      slug: 'sprint-packs',
      params: { limit: 100, page: 1, sort: 'updatedAt', order: 'DESC' }
    },
  ],

};





const details2 = [

  {
    Header: ({ collections, reports }) => {
      return (
        <>
          <IconChip tone="green">
            <PlanIcon />
          </IconChip>
          <h3 className="section-title">
            {reports.summary?.modules?.stratPlans?.byStatus?.active || 0}
          </h3>
        </>
      );
    },
    Detail: ({ collections, reports }) => {

      const sprintProgress = {
        planned: 25,
        active: 60,
        closed: 100,
      };

      const stratPlans = Array.isArray(collections.stratPlans) ? collections.stratPlans : [];

      const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

      const planProgressById = stratPlans.reduce((acc, plan) => {
        const planSprints = sprintPacks.filter((pack) => pack.stratPlanId === plan.id);
        const progress = planSprints.length
          ? Math.round(planSprints.reduce((sum, pack) => sum + (sprintProgress[pack?.status] || 0), 0) / planSprints.length)
          : 0;
        acc[plan.id] = progress;
        return acc;
      }, {});

      const featuredStratPlan = [...stratPlans].sort((a, b) => (planProgressById[b.id] || 0) - (planProgressById[a.id] || 0))[0];

      return (
        <>
          <p>Active StratPlans</p>
          <Link className="inline-link" to={featuredStratPlan ? `/strat-plans/${featuredStratPlan.id}` : '/strat-plans/new'}>
            View all →
          </Link>
        </>
      );
    }
  },

  {
    Header: ({ collections, reports }) => {
      return (
        <>
          <IconChip tone="blue">
            <RocketIcon />
          </IconChip>
          <h3 className="section-title">
            {reports.summary?.modules?.sprintPacks?.byStatus?.active || 0}
          </h3>
        </>
      );
    },
    Detail: ({ collections, reports }) => {

      const sprintProgress = {
        planned: 25,
        active: 60,
        closed: 100,
      };

      const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

      const featuredSprintPack = [...sprintPacks].sort((a, b) => (sprintProgress[b?.status] || 0) - (sprintProgress[a?.status] || 0))[0];

      return (
        <>
          <p>Active SprintPacks</p>
          <Link className="inline-link" to={featuredSprintPack ? `/sprint-packs/${featuredSprintPack.id}` : '/sprint-packs/new'}>
            View all →
          </Link>
        </>
      );
    }
  },

  {
    Header: ({ collections, reports }) => {
      return (
        <>
          <IconChip tone="purple">
            <CalendarIcon />
          </IconChip>
          <h3 className="section-title">
            {(reports.summary?.dateWindows?.overdue?.directionalStrategies || 0) + (reports.summary?.dateWindows?.overdue?.stratPlans || 0) + (reports.summary?.dateWindows?.overdue?.sprintPacks || 0)}
          </h3>
        </>
      );
    },
    Detail: ({ collections, reports }) => {

      const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

      const overdueReviewSprint = sprintPacks.filter((pack) => pack.endDate && new Date(pack.endDate) < new Date()).sort((a, b) => new Date(a.endDate) - new Date(b.endDate))[0];

      return (
        <>
          <p>Overdue Reviews</p>
          <Link className="inline-link" to={overdueReviewSprint ? `/sprint-packs/${overdueReviewSprint.id}` : '/reports'}>
            Review now →
          </Link>
        </>
      );
    }
  },

  {
    Header: ({ collections, reports }) => {
      return (
        <>
          <IconChip tone="gold">
            <CalendarIcon />
          </IconChip>
          <h3 className="section-title">
            {(reports.summary?.dateWindows?.upcoming?.directionalStrategies || 0) + (reports.summary?.dateWindows?.upcoming?.stratPlans || 0) + (reports.summary?.dateWindows?.upcoming?.sprintPacks || 0)}
          </h3>
        </>
      );
    },
    Detail: ({ collections, reports }) => {

      const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

      const nextReviewSprint = sprintPacks.filter((pack) => pack.endDate).sort((a, b) => new Date(a.endDate) - new Date(b.endDate))[0];

      return (
        <>
          <p>Upcoming Reviews</p>
          <Link className="inline-link" to={nextReviewSprint ? `/sprint-packs/${nextReviewSprint.id}` : '/sprint-packs/new'}>
            View calendar →
          </Link>
        </>
      );
    }
  },

];



const details3 = [

  {
    title: 'Recent Activity',
    linkTo: 'reports',
    linkLabel: 'View timeline',
    Detail: ({ collections, reports }) => {

      const activityFeed = Array.isArray(reports.activity) ? reports.activity : Array.isArray(reports.activity?.data) ? reports.activity.data : [];

      return (
        <ul className="activity-list">

          {activityFeed.map((event) => (

            <li key={`${event.entityType}-${event.entityId}-${event.updatedAt}`}>

              <div className="activity-item">

                <IconChip tone="green">
                  <ActivityIcon />
                </IconChip>

                <div>
                  <Link className="inline-link" to={((item) => {
                    if (!item) return '/dashboard';
                    if (item.entityType === 'directionalStrategy') return '/directional-strategies';
                    if (item.entityType === 'stratPlan') return `/strat-plans/${item.entityId}`;
                    if (item.entityType === 'sprintPack') return `/sprint-packs/${item.entityId}`;
                    if (item.entityType === 'task') return '/sprint-packs';
                    return '/dashboard';
                  })(event)}>
                    <strong>
                      {((item) => {
                        if (!item) return 'Activity item';
                        const type = String(item.entityType || '')
                          .replace(/([a-z])([A-Z])/g, '$1 $2')
                          .replace(/[_-]+/g, ' ');
                        const typeLabel = type ? `${type[0].toUpperCase()}${type.slice(1)}` : 'Item';
                        return `${typeLabel} updated: ${item.label || item.entityId}`;
                      })(event)}
                    </strong>
                  </Link>
                  <span className="activity-subtitle">
                    <StatusBadge value={event.status || 'updated'} />
                  </span>
                </div>

                <span className="activity-time">
                  {((value) => {
                    if (!value) return '-';
                    const date = new Date(value);
                    if (Number.isNaN(date.getTime())) return '-';
                    return date.toLocaleDateString();
                  })(event.updatedAt)}
                </span>

              </div>

            </li>

          ))}

          {activityFeed.length === 0 ? <li>No recent activity found.</li> : null}

        </ul>
      );
    }
  },

  {
    title: 'Strategic Plan Progress',
    linkTo: 'strat-plans',
    linkLabel: 'View report',
    Detail: ({ collections, reports }) => {

      const stratPlans = Array.isArray(collections.stratPlans) ? collections.stratPlans.slice(0, 6) : [];

      return (
        <div className="stack-sm">

          {stratPlans.map((plan) => {

            const sprintProgress = {
              planned: 25,
              active: 60,
              closed: 100,
            };

            const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

            const planSprints = sprintPacks.filter((pack) => pack.stratPlanId === plan.id);
            
            const progress = planSprints.length ? Math.round(planSprints.reduce((sum, pack) => sum + (sprintProgress[pack.status] || 0), 0) / planSprints.length) : 0;
            
            return (
              <div className="progress-row" key={plan.id}>
                <div className="row-between">
                  <Link className="inline-link plan-link" to={`/strat-plans/${plan.id}`}>
                    {plan.title}
                  </Link>
                  <span>{progress}%</span>
                </div>
                <div className="progress">
                  <div className="progress-fill" style={{ width: `${progress}%` }} />
                </div>
              </div>
            );
          })}

        </div>
      );
    }
  },

  {
    title: 'My StratPlans',
    linkTo: 'strat-plans',
    linkLabel: 'View all',
    Detail: ({ collections, reports }) => {
      return (
        <table className="data-table">

          {(() => {
            return (
              <thead>
                <tr>
                  <th>Plan Name</th>
                  <th>Priority</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Lead Sprint</th>
                  <th>Target Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
            );
          })()}


          {(() => {

            const stratPlans = Array.isArray(collections.stratPlans) ? collections.stratPlans : [];

            return (
              <tbody>

                {stratPlans.map((plan) => {

                  const sprintProgress = {
                    planned: 25,
                    active: 60,
                    closed: 100,
                  };

                  const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

                  const relatedSprintPack = sprintPacks.find((pack) => pack.stratPlanId === plan.id);
                  
                  const progress = relatedSprintPack ? sprintProgress[relatedSprintPack.status] || 0 : 0;
                  
                  return (
                    <tr key={plan.id}>

                      <td>
                        <Link className="inline-link" to={`/strat-plans/${plan.id}`}>
                          {plan.title}
                        </Link>
                      </td>

                      <td>{plan.priority || '-'}</td>

                      <td>
                        <div className="table-progress">
                          <div className="progress">
                            <div className="progress-fill" style={{ width: `${progress}%` }} />
                          </div>
                          <span>{progress}%</span>
                        </div>
                      </td>

                      <td><StatusBadge value={plan.status} /></td>

                      <td>{relatedSprintPack?.name || '-'}</td>

                      <td>{plan.endDate || '-'}</td>

                      <td className="table-actions">
                        <Link className="inline-link" to={`/strat-plans/${plan.id}`}>View</Link>
                        <Link className="inline-link" to={`/strat-plans/${plan.id}/edit`}>Edit</Link>
                        {relatedSprintPack ? <Link className="inline-link" to={`/sprint-packs/${relatedSprintPack.id}`}>Sprint</Link> : null}
                      </td>

                    </tr>
                  );
                })}

              </tbody>
            );
          })()}

        </table>
      );
    }
  },

  {
    title: 'SprintPack Lineup',
    linkTo: 'sprint-packs',
    linkLabel: 'Open board',
    Detail: ({ collections, reports }) => {

      const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks.slice(0, 5) : [];

      return (
        <ul className="simple-list">

          {sprintPacks.map((pack) => (
            
            <li key={pack.id}>
              <div className="activity-item">
                <IconChip tone={pack.status === 'active' ? 'blue' : 'purple'}>
                  <RocketIcon />
                </IconChip>
                <div>
                  <Link className="inline-link" to={`/sprint-packs/${pack.id}`}>
                    <strong>{pack.name}</strong>
                  </Link>
                  <span className="activity-subtitle">
                    {pack.startDate || 'TBD'} - {pack.endDate || 'TBD'}
                  </span>
                </div>
                <StatusBadge value={pack.status} />
              </div>
            </li>

          ))}

        </ul>
      );
    }
  },

];





const Component = () => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const [collections, setCollections] = useState({});
  const [reports, setReports] = useState({});

  useEffect(() => {

    const loadContext = async () => {
      setLoading(true);
      setError('');
      try {

        await ( async () => {

          const result = {};
          
          await Promise.all(
            model.collections.map( async ( item ) => {

              const Factory = require( '../../../records/modules' ).default;

              const response = await Factory( {
                slug: item.slug
              } ).Data.getRecords( item.params );

              result[ item.handle ] = Array.isArray(response?.data)
                ? response.data
                : Array.isArray(response)
                  ? response
                  : [];
            } )
          );

          setCollections( result );
        } )();

        await ( async () => {

          const result = {};

          await Promise.all(
            model.reports.map( async ( item ) => {
              result[ item.handle ] = await reportRecords( item.slug, item.params )
            } )
          );

          setReports( result );
        } )();

      } catch (err) {
        setError(err?.response?.data?.message || err.message || 'Unable to load dashboard data.');
      } finally {
        setLoading(false);
      }
    }

    loadContext();
  }, []);


  if (loading) return <p>Loading dashboard...</p>;
  if (error) return <p className="error-text">{error}</p>;


  return (
    <div className="stack">

      <header className={['page-header', 'dashboard-header'].filter(Boolean).join(' ')}>
        <div className={'dashboard-header-copy'}>
          <h1 className="page-title">Welcome back</h1>
          <p className="page-subtitle">Here is what is happening in your Strategy Workspace.</p>
        </div>
      </header>

      
      <section className="card dashboard-hero">

        <div className="row-between">
          <div className="metric-head">
            <IconChip tone="green">
              <PlanIcon />
            </IconChip>
            <div>
              <p className="eyebrow">Progress narrative</p>
              <h2 className="section-title">Execution health</h2>
            </div>
          </div>
        </div>

        {(() => {

          const sprintProgress = {
            planned: 25,
            active: 60,
            closed: 100,
          };

          const directionalStrategies = Array.isArray(collections.directionalStrategies) ? collections.directionalStrategies : [];

          const stratPlans = Array.isArray(collections.stratPlans) ? collections.stratPlans : [];

          const sprintPacks = Array.isArray(collections.sprintPacks) ? collections.sprintPacks : [];

          const workspaceProgress = Math.round(sprintPacks.reduce((sum, pack) => sum + (sprintProgress[pack?.status] || 0), 0) / sprintPacks.length);

          const active = sprintPacks.filter((pack) => pack.status === 'active').length;
          const planned = sprintPacks.filter((pack) => pack.status === 'planned').length;
          const closed = sprintPacks.filter((pack) => pack.status === 'closed').length;
          
          const planProgressById = stratPlans.reduce((acc, plan) => {
            const planSprints = sprintPacks.filter((pack) => pack.stratPlanId === plan.id);
            const progress = planSprints.length
              ? Math.round(planSprints.reduce((sum, pack) => sum + (sprintProgress[pack?.status] || 0), 0) / planSprints.length)
              : 0;
            acc[plan.id] = progress;
            return acc;
          }, {});

          const directionProgressById = directionalStrategies.reduce((acc, direction) => {
            const directionPlans = stratPlans.filter((plan) => plan.directionalStrategyId === direction.id);
            const progressValues = directionPlans.map((plan) => planProgressById[plan.id] || 0);
            const progress = progressValues.length
              ? Math.round(progressValues.reduce((sum, value) => sum + value, 0) / progressValues.length)
              : 0;
            acc[direction.id] = progress;
            return acc;
          }, {});

          const featuredStratPlan = [...stratPlans].sort((a, b) => (planProgressById[b.id] || 0) - (planProgressById[a.id] || 0))[0];

          const featuredSprintPack = [...sprintPacks].sort((a, b) => (sprintProgress[b?.status] || 0) - (sprintProgress[a?.status] || 0))[0];

          const featuredDirectionalStrategy = [...directionalStrategies].sort((a, b) => (directionProgressById[b.id] || 0) - (directionProgressById[a.id] || 0))[0];


          return (
            <div className="stack-sm">

              <div className="row-between">
                <span className="hero-stat-label">Overall progress</span>
                <strong>{workspaceProgress}%</strong>
              </div>

              <div className="progress">
                <div className="progress-fill" style={{ width: `${workspaceProgress}%` }} />
              </div>

              <p className="hero-copy">
                {sprintPacks.length ? `${active} active, ${planned} planned, and ${closed} closed sprint packs currently shape portfolio momentum.` : 'Create your first sprint pack to begin building momentum and progress signals.'}
              </p>

              <div className="hero-stats hero-stats-compact">
                <div className="hero-stat">
                  <span className="hero-stat-label">Active sprint packs</span>
                  <strong>{active}</strong>
                </div>
                <div className="hero-stat">
                  <span className="hero-stat-label">Closed sprint packs</span>
                  <strong>{closed}</strong>
                </div>
                <div className="hero-stat">
                  <span className="hero-stat-label">Plans in motion</span>
                  <strong>{new Set(sprintPacks.filter((pack) => pack.status === 'active').map((pack) => pack.stratPlanId)).size}</strong>
                </div>
                <div className="hero-stat">
                  <span className="hero-stat-label">Directions with momentum</span>
                  <strong>{directionalStrategies.filter((direction) => (directionProgressById[direction.id] || 0) > 0).length}</strong>
                </div>
              </div>

              <div className="stack-sm">
                <div className="leader-row">
                  <div className="row-between">
                    <span className="hero-stat-label">Lead direction</span>
                    <span><strong>{featuredDirectionalStrategy ? directionProgressById[featuredDirectionalStrategy.id] || 0 : 0}%</strong></span>
                  </div>
                  <div className="row-between">
                    <Link className="inline-link plan-link" to={featuredDirectionalStrategy
                      ? `/directional-strategies/${featuredDirectionalStrategy.id}`
                      : '/directional-strategies'}>
                      {featuredDirectionalStrategy?.title || 'Browse directional strategies'}
                    </Link>
                  </div>
                  <div className="progress">
                    <div className="progress-fill" style={{ width: `${featuredDirectionalStrategy ? directionProgressById[featuredDirectionalStrategy.id] || 0 : 0}%` }} />
                  </div>
                </div>
                <div className="leader-row">
                  <div className="row-between">
                    <span className="hero-stat-label">Lead plan</span>
                    <span><strong>{featuredStratPlan ? planProgressById[featuredStratPlan.id] || 0 : 0}%</strong></span>
                  </div>
                  <div className="row-between">
                    <Link className="inline-link plan-link" to={featuredStratPlan
                      ? `/strat-plans/${featuredStratPlan.id}`
                      : '/strat-plans'}>
                      {featuredStratPlan?.title || 'Browse strategic plans'}
                    </Link>
                  </div>
                  <div className="progress">
                    <div className="progress-fill" style={{ width: `${featuredStratPlan ? planProgressById[featuredStratPlan.id] || 0 : 0}%` }} />
                  </div>
                </div>
                <div className="leader-row">
                  <div className="row-between">
                    <span className="hero-stat-label">Lead sprint</span>
                    <span><strong>{featuredSprintPack ? (sprintProgress[featuredSprintPack?.status] || 0) : 0}%</strong></span>
                  </div>
                  <div className="row-between">
                    <Link className="inline-link plan-link" to={featuredSprintPack
                      ? `/sprint-packs/${featuredSprintPack.id}`
                      : '/sprint-packs'}>
                      {featuredSprintPack?.name || 'Browse sprint packs'}
                    </Link>
                  </div>
                  <div className="progress">
                    <div className="progress-fill" style={{ width: `${featuredSprintPack ? (sprintProgress[featuredSprintPack?.status] || 0) : 0}%` }} />
                  </div>
                </div>
              </div>

            </div>
          );
        })()}

      </section>





      <div className="card-grid metrics-grid">

        {details2.map( ( Detail ) => {
          return (
            <article className="card metric-card">
              <div className="metric-head">
                <Detail.Header collections={collections} reports={reports} />
              </div>
              <Detail.Detail collections={collections} reports={reports} />
            </article>
          );
        } )}

      </div>


      <div className="card-grid">

        {details3.map( ( Detail ) => {
          return (
            <section className="card">

              <div className="row-between">
                <h3 className="section-title">{Detail.title}</h3>
                <Link className="inline-link" to={`/${Detail.linkTo}`}>
                  {Detail.linkLabel} →
                </Link>
              </div>

              <Detail.Detail collections={collections} reports={reports} />

            </section>
          );
        } )}

      </div>


    </div>
  );
}

export default Component;
